<template>

  <b-row>

    <b-col
        md="6"
        xl="6"
        class="mb-1"
    >
      <b-card-code title="Preisrechner">
        <b-row v-for="wp in Waypoints">
          <b-col
              md="12"
              xl="12"
          >
            <b-form-group
                label="Adresse"
            >
              <b-form-input
                  v-model="wp.Street"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-code>
    </b-col>
  </b-row>
</template>


<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormDatepicker
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import BCardCode from '@core/components/b-card-code'

export default {
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      loading: false,
      Waypoints: [
          {
        Street: ''
      },
        {
          Street: ''
        }
      ],

    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Preisrechner'
    })
  },
  methods: {
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },

  },
}
</script>
